import React, { useEffect } from "react";
import { Button } from "reactstrap";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { useRole } from "../../../../redux/slices/authSlice";
import ControlledDropDown from "../../Forms/Controller/ControlledDropDown";
import { MdDelete } from "react-icons/md";
import InputField from "../../Forms/InputField/InputField";
import { PaymentMetaLabelListGet } from "../../../../redux/slices/transactionSlice";
import { useDispatch, useSelector } from "react-redux";
import CustomeButton from "../../Forms/CustomeButton/CustomeButton";

const Merchant = (props) => {
  const {
    changeBankModal,
    merchants,
    bankId,
    bankOptions,
    paymentMetaLabelListGetData,
    preparepgDataOptions,
    showTableData,
    setMerchantList,
    merchantList = [],
    handleSubmit,
    submitLoader,
  } = props;

  const [paymentMetaLabelListGetData1, setPaymentMetaLabelListGetData1] =
    useState([]);
  const [loading, setLoading] = useState({
    pgLoading: false,
    pgAccLoading: false,
  });
  const { transactionFilterState } = useSelector((state) => state.transaction);
  const role = useRole("Static Pg Meta");
  const dispatch = useDispatch();

  const bankName = paymentMetaLabelListGetData?.data?.find((data) => {
    return data?.acId == bankId;
  })?.note;

  const initialValues = {
    merchantEmail: "",
    merchantName: "",
    Mode: "merchant",
    BankSelect: "",
    BankPercentage: "",
    MerchantSelect: "",
    BankForMerchant: "",
    pgName: "",
  };

  const {
    control,
    getValues,
    setValue,
    setError,
    watch,
    clearErrors,
    resetField,
    formState: { errors },
  } = useForm({
    defaultValues: initialValues,
  });

  const PaymentMetaLabelList = async () => {
    try {
      const pgName = transactionFilterState?.pg_data?.find((data) => {
        return data?.pg_id == watch("pgName");
      });
      let payload = {
        pgType: "payin",
        pgName: pgName?.pg_name ? [pgName?.pg_name] : "All",
        pg_id: watch("pgName") || "all",
        notSetState: true,
      };
      setLoading({ ...loading, pgAccLoading: true });
      const res = await dispatch(PaymentMetaLabelListGet(payload)).unwrap();
      if (res?.status) {
        setPaymentMetaLabelListGetData1(res);
      }
      setLoading({ ...loading, pgAccLoading: false });
    } catch (e) {
      setLoading({ ...loading, pgAccLoading: false });
    }
  };

  const pgName = watch("pgName");

  useEffect(() => {
    if (pgName && changeBankModal) {
      PaymentMetaLabelList(); // make sure this doesn’t itself set pgName
    }
  }, [pgName, changeBankModal]);

  const extractValue = (field) => {
    if (field == null) return "";
    if (typeof field === "object" && "value" in field) return field.value;
    return field;
  };

  const findLabel = (options, val) => {
    const found = options?.find?.((o) => o.value === val || o.label === val);
    return found ? found.label : val;
  };

  const handleDeleteMerchant = (index) => {
    const newList = [...merchantList];
    newList.splice(index, 1);
    setMerchantList(newList);
  };

  const onClickAddMerchant = async () => {
    const fromBank = getValues("fromBank");
    const pgName = getValues("pgName");
    const merchantField = getValues("MerchantSelect");
    const bankField = getValues("BankForMerchant");
    const pgNameVal = extractValue(pgName);
    const fromBankVal = extractValue(fromBank);
    const merchantVal = extractValue(merchantField);
    const bankVal = extractValue(bankField);
    if (!fromBankVal && !showTableData && !changeBankModal?.pg_id) {
      setError("fromBank", {
        type: "manual",
        message: "Please select from bank.",
      });
      return;
    } else {
      clearErrors("fromBank");
    }

    if (!merchantVal) {
      setError("MerchantSelect", {
        type: "manual",
        message: "Please select a merchant.",
      });
      return;
    } else {
      clearErrors("MerchantSelect");
    }

    if (!pgNameVal) {
      setError("pgName", {
        type: "manual",
        message: "PG Name Is Required",
      });
      return;
    } else {
      clearErrors("pgName");
    }

    if (!bankVal) {
      setError("BankForMerchant", {
        type: "manual",
        message: "PG Account Is Required",
      });
      return;
    } else {
      clearErrors("BankForMerchant");
    }

    const toBankName = paymentMetaLabelListGetData1?.data?.find((data) => {
      return data?.acId == bankVal;
    })?.note;

    setMerchantList([
      ...merchantList,
      {
        merchant: merchantVal,
        bank: bankVal,
        fromBank,
        toBank: toBankName,
        pgName: pgNameVal,
      },
    ]);

    if (!showTableData && !changeBankModal?.pg_id) {
      await handleSubmit?.([
        ...merchantList,
        {
          merchant: merchantVal,
          bank: bankVal,
          fromBank,
          toBank: toBankName,
          pgName: pgNameVal,
        },
      ]);
    }
    setValue("MerchantSelect", "");
    setValue("BankForMerchant", "");
    setValue("fromBank", "");
    setValue("pgName", "");
  };

  const getpgAccDataOptions = () => {
    const options = paymentMetaLabelListGetData1?.data
      ?.slice()
      ?.sort((a, b) => a?.note?.localeCompare(b?.note))
      ?.map?.((val) => {
        const pgAccDataOption = { value: val?.acId, label: val?.note };
        return pgAccDataOption;
      });
    return options;
  };

  const allMerchantOptions = React.useMemo(() => {
    return (
      merchants?.slice()?.map?.((val) => ({
        value: val?.merchant_details?.merchant_id,
        label: val?.merchant_details?.admin_merchant_name,
      })) || []
    );
  }, [merchants]);

  const prepareMerchantOptions = React.useMemo(() => {
    const addedIds = merchantList?.map?.((m) => m?.merchant);
    return allMerchantOptions?.filter?.(
      (opt) => !addedIds?.includes?.(opt?.value)
    );
  }, [allMerchantOptions, merchantList]);

  const allBankOptions = React.useMemo(() => {
    const pgLabels = merchants?.map?.((item) => ({
      value: item?.pg_id,
      label: item?.bank_details?.label || null,
    }));
    return (
      pgLabels?.filter?.((options) => {
        return options?.value !== bankName;
      }) || []
    );
  }, [merchants]);

  const merchantsForPerMer = () => {
    const merchantIds = changeBankModal?.merchant_ids?.split?.(",");
    const selectedMerchants = merchantIds
      ?.map?.((id) => {
        const found = transactionFilterState?.cilent_data?.find?.(
          (m) => m?.merchantId === id
        );
        return found
          ? { value: found?.merchantId, label: found?.merchantName }
          : null;
      })
      ?.filter?.(Boolean);

    return selectedMerchants;
  };

  const prepareMerchantPerMer = React.useMemo(() => {
    const addedIds = merchantList?.map?.((m) => m?.merchant);
    return merchantsForPerMer()?.filter?.(
      (opt) => !addedIds?.includes?.(opt?.value)
    );
  }, [merchantsForPerMer, merchantList]);

  const merchantsForPerMerForAll = () => {
    const allMerchants = merchants
      ?.filter((item) => item?.pg_id === watch("fromBank"))
      ?.flatMap?.((item) => item?.merchant_ids?.split?.(","))
      ?.map?.((id) => {
        const found = transactionFilterState?.cilent_data?.find?.(
          (m) => m?.merchantId === id
        );
        return {
          value: id,
          label: found?.merchantName || null,
        };
      });
    return allMerchants;
  };

  const merchantsForPerMerForAll1 = () => {
    const allMerchants = merchants
      ?.flatMap?.((item) => item?.merchant_ids?.split?.(","))
      ?.map?.((id) => {
        const found = transactionFilterState?.cilent_data?.find?.(
          (m) => m?.merchantId === id
        );
        return {
          value: id,
          label: found?.merchantName || null,
        };
      });
    return allMerchants;
  };
  const prepareMerchantForAll = React.useMemo(() => {
    const addedIds = merchantList?.map?.((m) => m?.merchant);
    return merchantsForPerMerForAll()?.filter?.(
      (opt) => !addedIds?.includes?.(opt?.value)
    );
  }, [merchantsForPerMerForAll, merchantList, watch("fromBank"), merchants]);

  const bankForMerchantOptions = React.useMemo(() => {
    return getpgAccDataOptions()?.filter?.((opt) => opt.value !== bankId);
  }, [getpgAccDataOptions, bankId, watch("pgName")]);

  const filteredToBanks = React.useMemo(() => {
    return getpgAccDataOptions()?.filter?.(
      (opt) => opt.value !== changeBankModal?.pg_id
    );
  }, [getpgAccDataOptions, changeBankModal?.pg_id, watch("pgName")]);

  const filteredToBanksForAll = React.useMemo(() => {
    return getpgAccDataOptions()?.filter?.(
      (opt) => opt.value !== watch("fromBank")
    );
  }, [getpgAccDataOptions, watch("fromBank"), watch("pgName")]);

  if (!role.includes("static-pg-meta-list") || !changeBankModal) {
    return;
  }

  return (
    <>
      <div className="change_grid mb-1">
        {!showTableData && !changeBankModal?.pg_id ? (
          <ControlledDropDown
            name="fromBank"
            label="From Bank"
            options={allBankOptions}
            isDisabled={!allBankOptions?.length}
            onChange={(e) => {
              setValue("fromBank", e?.value);
              resetField("MerchantSelect");
              if (e?.value) {
                clearErrors("fromBank");
              }
            }}
            control={control}
            errors={errors}
          />
        ) : (
          <InputField
            name="fromBank"
            readOnly
            value={
              showTableData && !changeBankModal?.pg_id
                ? bankName
                : changeBankModal?.bank_details?.label
            }
            label="From Bank"
          />
        )}
        <ControlledDropDown
          name="MerchantSelect"
          label="Select Merchant"
          options={
            !showTableData && !changeBankModal?.pg_id
              ? prepareMerchantForAll
              : !showTableData && !!changeBankModal?.pg_id
                ? prepareMerchantPerMer
                : prepareMerchantOptions
          }
          isDisabled={
            !prepareMerchantOptions?.length ||
            (!showTableData &&
              !!changeBankModal?.pg_id &&
              !prepareMerchantPerMer?.length)
          }
          control={control}
          errors={errors}
        />
        <ControlledDropDown
          label="PG"
          name="pgName"
          isDefaultOption={false}
          isDisabled={
            !prepareMerchantOptions?.length ||
            (!showTableData &&
              !!changeBankModal?.pg_id &&
              !prepareMerchantPerMer?.length)
          }
          options={preparepgDataOptions}
          onChange={(e) => {
            setValue("pgName", e?.value);
            resetField("BankForMerchant");
            if (e?.value) {
              clearErrors("pgName");
            }
          }}
          control={control}
          errors={errors}
        />
        <ControlledDropDown
          label="PG Account"
          name="BankForMerchant"
          isDisabled={
            !prepareMerchantOptions?.length ||
            loading?.pgAccLoading ||
            (!showTableData &&
              !!changeBankModal?.pg_id &&
              !prepareMerchantPerMer?.length)
          }
          isDefaultOption={false}
          isLoading={loading?.pgAccLoading}
          options={
            !showTableData && !changeBankModal?.pg_id
              ? filteredToBanksForAll
              : !showTableData && !!changeBankModal?.pg_id
                ? filteredToBanks
                : bankForMerchantOptions
          }
          control={control}
          errors={errors}
        />
        <div style={{ marginTop: "28px" }}>
          <CustomeButton
            type="button"
            className="btn btn-primary"
            onClick={onClickAddMerchant}
            isButtonLoading={
              submitLoader && !showTableData && !changeBankModal?.pg_id
            }
            disabled={
              !prepareMerchantOptions?.length ||
              (!showTableData &&
                !!changeBankModal?.pg_id &&
                !prepareMerchantPerMer?.length)
            }
          >
            {!showTableData && !changeBankModal?.pg_id ? "Submit" : "Add"}
          </CustomeButton>
        </div>
      </div>

      {merchantList?.length && !(!showTableData && !changeBankModal?.pg_id) ? (
        <>
          <div
            className={`${!showTableData && !changeBankModal?.pg_id
                ? "change_bank_grid"
                : "change_bank_grid_1"
              } change_bank_header`}
          >
            {!showTableData && !changeBankModal?.pg_id ? (
              <span>From Bank</span>
            ) : null}

            <span>Merchant</span>
            <span>Bank</span>
            <span>Action</span>
          </div>

          {merchantList?.map?.((item, idx) => (
            <div
              key={idx}
              className={`${!showTableData && !changeBankModal?.pg_id
                  ? "change_bank_grid"
                  : "change_bank_grid_1"
                }`}
            >
              {!showTableData && !changeBankModal?.pg_id ? (
                <span>{findLabel(bankOptions, item.fromBank)}</span>
              ) : null}
              <span>
                {findLabel(
                  !showTableData && !changeBankModal?.pg_id
                    ? merchantsForPerMerForAll1()
                    : !showTableData && !!changeBankModal?.pg_id
                      ? merchantsForPerMer()
                      : allMerchantOptions,
                  item?.merchant
                )}
              </span>
              <span>{item?.toBank}</span>
              <Button
                type="button"
                color="danger"
                onClick={() => handleDeleteMerchant(idx)}
              >
                <MdDelete />
              </Button>
            </div>
          ))}
        </>
      ) : null}
    </>
  );
};

export default Merchant;
